<template>
  <b-modal
    id="take-products-modal"
    dialog-class="modal-fullsize"
    hide-footer
    hide-header
    @show="onShow"
  >
    <div class="goods">
      <ProductBrowser @selectProduct="appendProduct" />
      <div class="goods-aside">
        <h2>Masowy wybór materiałów</h2>
        <b-form-input 
          id="constructionName"
          class="mb-4"
          v-model="construction.name"
          disabled
        />
        <div class="goods-aside-buttons">
          <b-button variant="primary" @click="validSubmit">Dodaj do oferty</b-button>
          <b-button variant="danger" @click="$bvModal.hide('take-products-modal')">Anuluj</b-button>
        </div>
        <!-- products list -->
        <ProductsSelectedList
          :products="query.products"
          @increment="appendProduct"
          @decrement="reduceProduct"
          @setInput="setInput"
          @remove="removeProduct"
        />
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ProductBrowser from "./ProductBrowser";
import ProductsSelectedList from "./ProductsSelectedList";

export default {
  components: { ProductBrowser, ProductsSelectedList },
  props: {
    construction: Object
   },
  data() {
    return {
      sign: 1,
      query: {
        products: [],
      }
    };
  },
  computed: {
    ...mapGetters("products", ["products"])
  },
  mounted() {
    if (this.issuance === true) {
      this.loadProjects().then(() => {
        this.loadingConstructions = false;
      });
    }
  },
  methods: {
    ...mapActions("projectslist", ["loadProjects"]),
    onShow() {
      this.query.products = [];
    },
    appendProduct(product) {
      let queryProduct = this.query.products.find(
        ({ id }) => id == product.id
      );
      if (!queryProduct) {
        this.query.products.push({
          id: product.id,
          category_id: product.category_id,
          name: product.name,
          description: product.description,
          quantity: 1,
          unit: product.unit,
          netto_amount: product.netto_amount,
          vat_rate: product.vat_rate,
        });
      } else {
        queryProduct.quantity++;
      }
    },
    reduceProduct(product) {
      if (product.quantity == 0) return;
      product.quantity--;
      if (product.quantity <= 0) {
        this.removeProduct(product);
      }
    },
    removeProduct(product) {
      let indexToRemove = this.query.products.findIndex(
        ({ id }) => id == product.id
      );
      if (indexToRemove > -1) this.query.products.splice(indexToRemove, 1);
    },
    setInput(product, value) {
      const storageProduct = this.products.find(
        ({ id }) => id == product.id
      );
      if (this.sign < 0 && value > 0) {
        if (storageProduct.quantity === 0) {
          //goofy force refresh
          let tmp = product.quantity;
          product.quantity -= 1;
          this.$nextTick(function() {
            product.quantity = tmp;
          });
          return;
        } else if (value > storageProduct.quantity) {
          value = storageProduct.quantity;
        }
      }
      product.quantity += value;
      if (product.quantity <= 0) {
        this.removeProduct(product);
      }
    },
    validSubmit() {
      if (this.query.products.length === 0) {
        this.$store.commit("lastapimessage/push", {
          message: "Lista wybranych produktów nie może być pusta.",
          type: "warning"
        });
        return;
      }
      this.$emit("submit", this.query);
    }
  }
};
</script>